import {
  RECEIVE_OPERATIONS,
  RECEIVE_OPERATIONS_AND_FIELDS,
  RECEIVE_MULTIPLE_OPERATIONS,
  RECEIVE_MULTIPLE_OPERATIONS_AND_FIELDS,
} from '../constants/actionTypes';

export function receiveOperations(operationId, operations) {
  return {
    // This operation comes from the farmer navigation and not from any saga.
    type: RECEIVE_OPERATIONS,
    operationId,
    operations,
  };
}

export function receiveMultipleOperations(selectedOperations, allOperations) {
  return {
    // These selected operations comes from farmer navigation and not from any saga.
    type: RECEIVE_MULTIPLE_OPERATIONS,
    selectedOperations,
    allOperations
  };
}

export function receiveOperationsFields(operations, operationId, fields) {
  return {
    type: RECEIVE_OPERATIONS_AND_FIELDS,
    operations,
    operationId,
    fields,
  };
}

export function receiveMultipleOperationsFields(selectedOperations, allOperations, fields) {
  return { 
    type: RECEIVE_MULTIPLE_OPERATIONS_AND_FIELDS,
    selectedOperations,
    allOperations,
    fields,
  };
}
